import React from 'react';
import styles from '../Operations.module.css';
import KpiFocusArea from '../../../../components/kpifocusarea';

interface MGISComponent extends React.FC {
  title?: string;
  kpiHyperlink?: string;
  actionTitle?: string;
  actionContent?: React.FC;
  actionDrawerWidth?: number;
}

/**
 * MGIS - Mango In-Stock Opportunity
 * KPI information component
 */
const MGIS: MGISComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>Metric Description</div>

      <div className={styles.sectionContent}>
        This grid is available between the 5th and End of month showing you Ace SKUs having sold to
        zero on hand during the trailing twelve months.
        <br /><br />
        Mango will calculate a suggested minimum order point for each SKU designed to keep you in
        stock limiting those lost sales and returning it to your bottom line.
      </div>

      <div className={styles.sectionTitle}>Supporting Details</div>

      <div className={styles.sectionContent}>
        When consumers are asked what frustrates them the most when shopping, one response topping
        the list is the aggravation caused when an item is out of stock.
        <br /><br />
        In fact, almost a third of all customers who experience an out-of-stock leave the store and
        purchase the item elsewhere.
      </div>

      <div className={styles.sectionContent}>
        Not only are you at risk of customer satisfaction, but each out-of-stock costs approximately
        $0.58 per SKU, per day in lost sales.
        <br /><br />
        The average Ace store potentially loses more than $70,000 in annual sales.
      </div>

      <div className={styles.sectionTitle}>Goal</div>

      <div className={styles.sectionContent}>
        In Stock Opportunity &lt;1%
        <br />
        <br />
        If your metric is 1.1% then your store would see an increase of 1.1% in annual sales if it
        never sold out of inventory.
        <br /><br />
        SKU lists (and metric) exclude outs caused by RSC (retail support center), special orders,
        in/out promotional items and other noise.
      </div>

      <div className={styles.sectionTitle}>Learn More</div>

      <div className={styles.sectionContent}>
        <a
          href="https://acenet.aceservices.com/awor/inventory-management/in-stock-position/in-stock-position-summary"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          See Task 8 in the In-Stock Position Setup Ace Way of Retailing document for instructions
        </a>
      </div>
    </div>
  );
};

/**
 * MGISTakeAction - Take Action drawer content for MGIS
 */
const MGISTakeAction: React.FC = () => (
  <KpiFocusArea
    kpiCodes={['MGIS']}
    automationLinks={[
      { label: 'Mango In-Stock Opportunity', urlCode: 'MGIS', urlField: 'automationurl' },
    ]}
    automationTitle="For Optimal Shelf Quantity Automation:"
  />
);

MGIS.title = 'Mango In-Stock Opportunity';
MGIS.kpiHyperlink = 'https://www.mangoreport.com/radmangoinstock';
MGIS.actionTitle = 'Review Opportunities';
MGIS.actionDrawerWidth = 925;
MGIS.actionContent = MGISTakeAction;
export default MGIS;
